import * as React from 'react';
import Stack from '@kiwicom/orbit-components/lib/Stack';
import FlightDirect from '@kiwicom/orbit-components/lib/icons/FlightDirect';
import {
  CommonBookingInfoViewHeaderItineraryTypeEnum,
  CommonBookingInfoViewHeaderDisplayStopsInner,
} from '@kiwicom/openapi-sdk/mmb';
import Text from '@kiwicom/orbit-components/lib/Text';
import { FormattedMessage } from 'react-intl';

const Stop = ({ isLast, name }: { isLast: boolean; name: string }) => (
  <>
    <Text as="span" size="large" weight="bold">
      {name}
    </Text>
    {!isLast && <FlightDirect dataTest="display-stop-arrow" reverseOnRtl size="large" ariaHidden />}
  </>
);

type Props = {
  stops: CommonBookingInfoViewHeaderDisplayStopsInner[];
  itineraryType: CommonBookingInfoViewHeaderItineraryTypeEnum | null;
};

const ItineraryStops = ({ stops, itineraryType }: Props) => (
  <Stack spacing="100" direction="row" wrap>
    {stops.map((stop, i) => (
      <Stop isLast={stops.length - 1 === i} name={stop.name} key={stop.name} />
    ))}
    {itineraryType === CommonBookingInfoViewHeaderItineraryTypeEnum.Return && (
      <Text size="large" as="span">
        <FormattedMessage id="mmb.header.and_back" defaultMessage="and back" />
      </Text>
    )}
  </Stack>
);

export default ItineraryStops;
